import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid, useMediaQuery } from "@material-ui/core";
import {
  SimpleLoading,
  PromotionalFooterPure,
  ButtonAddHLPure,
  ButtonHLPure,
} from "../../pures";
import { ClientDocument } from "../../../services";
import {
  HeaderHLPure,
  FilterHLPure,
  GridHLPure,
  DialogSystemGLPure,
  SearchBarHLPure,
  DialogYesNoHLPure,
} from "../../pures";
import "./documents-to-require.css";
import DocumentsToRequireConfigurationView from "./documents-to-require-pages/documents-to-require-configurations.view";

const DocumentsToRequireView = (props) => {
  const {
    documents,
    toggleErrorRequesting,
    toggleCompletedRequesting,
    toggleLoadingRequesting,
    personTypes,
    goBackRoute,
  } = props;
  const { t } = useTranslation();
  let ENV = process.env

  const [showLoadingRequesting, setShowLoadingRequesting] = useState(false);
  const [showErrorRequesting, setShowErrorRequesting] = useState(false);
  const [showCompletedRequesting, setShowCompletedRequesting] = useState(false);
  const [dataUserFiltered, setDataUserFiltered] = useState(documents.documentsContractorPhysical);
  const [selectedValueFilter, setSelectedValue] = useState(ENV.REACT_APP_PERSON_TYPE_CONTRACTOR_PHYSICAL);
  const [searchValue, setSearchValue] = useState("");
  const [selectedUser, setSelectedUser] = useState({});
  const [showDetails, setShowDetails] = useState(false);
  const [nameComponentUser, setNameComponentUser] = useState("");
  const [headerTitleinDetail, setHeaderTitleinDetail] = useState({
    clicked: false,
    name: "",
  });
  const [dataItemUser, setDataItemUser] = useState({});
  const [showDialogYesNo, setShowDialogYesNo] = useState(false);
  const textLimit = useMediaQuery('(max-width:820px)')

  //Filter Function, convert to boolean
  const strToboolean = (value) => {
    if (value && typeof value === "string") {
      if (value.toLowerCase() === "true") return true;
      if (value.toLowerCase() === "false") return false;
    }
    return value;
  };

  //Filter Function, get selected value
  const filterChange = (e) => {
    const selectedOption = strToboolean(e.target.value);
    setSelectedValue(selectedOption);
  };

  //Filter Function, filter elements and update grid
  useEffect(() => {
    // let usersCopy = [...dataUserFiltered];
    let usersCopy = [...documents.documentsContractorPhysical]

    if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_CONTRACTOR_MORAL) {
      usersCopy = [...documents.documentsContractorMoral];
    } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_REPSE_PHYSICAL) {
      usersCopy = [...documents.documentsRepsePhysical];
    } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_REPSE_MORAL) {
      usersCopy = [...documents.documentsRepseMoral];
    } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_CONTRACT_REPSE) {
      usersCopy = [...documents.documentsContractREPSE];
    } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_REPORT_REPSE) {
      usersCopy = [...documents.documentsReportREPSE];
    } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_PROCEDURE_USER) {
      usersCopy = [...documents.documentsProcedureUser];
    } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_SIGNERS) {
      usersCopy = [...documents.documentsSigners];
    } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_ASSEMBLIES) {
      usersCopy = [...documents.documentsAssemblies];
    }


    let dataUpadate = usersCopy.filter(
      (user) => user.documentTypes.value === selectedValueFilter &&
        (user.name.toLowerCase().includes(searchValue.toLowerCase()) ||
          user.name.includes(searchValue.toLowerCase()))
    );
    setDataUserFiltered(dataUpadate);

    // // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedValueFilter, searchValue]);

  //Update state information from grid
  useEffect(() => {
    setSelectedValue(selectedValueFilter)

    let dataUpdate = documents.documentsContractorPhysical
    if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_CONTRACTOR_MORAL) {
      dataUpdate = documents.documentsContractorMoral
    } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_REPSE_PHYSICAL) {
      dataUpdate = documents.documentsRepsePhysical
    } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_REPSE_MORAL) {
      dataUpdate = documents.documentsRepseMoral
    } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_CONTRACT_REPSE) {
      dataUpdate = documents.documentsContractREPSE
    } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_REPORT_REPSE) {
      dataUpdate = documents.documentsReportREPSE
    } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_PROCEDURE_USER) {
      dataUpdate = documents.documentsProcedureUser
    } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_SIGNERS) {
      dataUpdate = documents.documentsSigners
    } else if (selectedValueFilter === ENV.REACT_APP_PERSON_TYPE_ASSEMBLIES) {
      dataUpdate = documents.documentsAssemblies
    }


    setDataUserFiltered(dataUpdate);
  }, [documents]);

  // useEffect(() => {
  //   setDataUserFiltered(documentsMoral);
  // }, [documentsMoral]);
  //Search Function, get value search input
  const searchChange = (e) => {
    e.preventDefault();
    setSearchValue(e.target.value);
  };

  const setHeaderTitle = () => {
    const name = headerTitleinDetail.name || nameComponentUser;
    switch (name) {
      case "":
        return t("documentsToRequire.titleHeader");
      case t("documentsToRequire.grid.detailAndEdit"):
        return t("documentsToRequire.roleAssignTitle");
      case t("documentsToRequire.newDocument"):
        return t("documentsToRequire.addDocumentTitle");
      default:
        return t("documentsToRequire.titleHader");
    }
  };

  useEffect(() => {
    if (headerTitleinDetail.clicked) {
      setHeaderTitle();
    }
    setHeaderTitle();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nameComponentUser, headerTitleinDetail]);

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  //DialogYesNoHLpure funtion to show o not show
  const toggleDialogYesNo = (dataItem, value) => {
    setDataItemUser(dataItem);
    setShowDialogYesNo(value);
  };

  const deleteClientDocument = async () => {
    setShowLoadingRequesting(true);
    toggleDialogYesNo(dataItemUser, true);
    try {
      toggleDialogYesNo(dataItemUser, false)
      let clientDocument = new ClientDocument(
        process.env.REACT_APP_MIFIRMA_API
      );
      let res = await clientDocument.deleteClientDocument(
        dataItemUser.id,
        props.token
      );
      if (res && res.status === 200) {
        let documents = await clientDocument.getClientDocumentA3Cloud(
          dataItemUser.clientId,
          props.token
        );
        documents.data.data.map((documento) => {
          documento.newUpdatedDate = `${t("documentsToRequire.grid.modifiedOn")} ${document.updatedDate}}`;
          documento.activeBtnOne =
            documento.defaultDocument === true ? false : true;
          documento.labelBtnTwo =
            documento.defaultDocument === true
              ? t("documentsToRequire.grid.detail")
              : t("documentsToRequire.grid.detailAndEdit");
          return documents.data.data;
        });

        let documentsContractorPhysical = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_CONTRACTOR_PHYSICAL_KEY;
        });

        let documentsContractorMoral = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_CONTRACTOR_MORAL_KEY;
        });

        let documentsRepsePhysical = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_REPSE_PHYSICAL_KEY;
        });

        let documentsRepseMoral = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_REPSE_MORAL_KEY;
        });

        let documentsContractREPSE = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_CONTRACT_REPSE_KEY;
        });

        let documentsReportREPSE = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_REPORT_REPSE_KEY;
        });

        let documentsProcedureUser = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_PROCEDURE_USER_KEY;
        });

        let documentsSigners = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_SIGNERS_KEY;
        });


        let documentsAssemblies = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_ASSEMBLIES_KEY;
        });

        setShowLoadingRequesting(false);
        setShowCompletedRequesting(true);
        await toggleCompletedRequesting(
          true,
          "",
          documentsContractorPhysical,
          documentsContractorMoral,
          documentsRepsePhysical,
          documentsRepseMoral,
          documentsContractREPSE,
          documentsReportREPSE,
          documentsProcedureUser,
          documentsSigners,
          documentsAssemblies
        );
        setTimeout(() => {
          setShowCompletedRequesting(false);
        }, 4000);
      } else {
        toggleLoadingRequesting(false);
        setTimeout(() => {
        }, 4000);
      }
    } catch (error) {
      toggleLoadingRequesting(false);
      // toggleErrorRequesting(true);
      setShowErrorRequesting(true);
      setTimeout(() => {
      }, 4000);
      return false;
    }
  };

  return (
    <div className="standard-wrapper">
      {props.loading ? (
        <SimpleLoading />
      ) : (

        <Container
          lg={12}
          md={12}
          spacing={4}
          className="documentsToRequire-container"
        >
          {showErrorRequesting ? (
            <DialogSystemGLPure
              showErrorRequesting={showErrorRequesting}
              toggleErrorRequesting={() => setShowErrorRequesting(!showErrorRequesting)}
            />
          ) : null}
          {showLoadingRequesting ? (
            <DialogSystemGLPure
              showLoadingRequesting={showLoadingRequesting}
              toggleLoadingRequesting={() => setShowLoadingRequesting(!showLoadingRequesting)}
            />
          ) : null}
          {showCompletedRequesting ? (
            <DialogSystemGLPure
              showCompletedRequesting={showCompletedRequesting}
              toggleCompletedRequesting={() => setShowCompletedRequesting(!showCompletedRequesting)}
              message={"El documento ha sido modificado con exito"}
            />
          ) : null}
          <Grid
            container
            className="documentsToRequire-body"
            xs={12}
            lg={12}
            md={12}
            sm={12}
            es={12}
          >
            {showDetails &&
              nameComponentUser &&
              nameComponentUser !== t("documentsToRequire.grid.delete") ? (
              <DocumentsToRequireConfigurationView
                {...props}
                nameComponentUser={nameComponentUser}
                selectedUser={selectedUser}
                selectedValueFilter={selectedValueFilter}
                hideShowDetails={() => {
                  setShowDetails(false);
                  setNameComponentUser("");
                  setHeaderTitleinDetail({ clicked: false, name: "" });
                }}
                toggleCompletedRequesting={toggleCompletedRequesting}
                toggleLoadingRequesting={toggleLoadingRequesting}
                token={props.token}
                clientId={props?.user?.userMetaData?.userMifirma?.clientId}
                rolesBySignatureProfile={props.rolesBySignatureProfile}
                setHeaderTitleinDetail={setHeaderTitleinDetail}
                validators={props.validators}
                forceRefresh={props.forceRefresh}
                typeDocuments={props.typeDocuments}
                preferenceValue={props.preferenceValue}
                newOptions={props.newOptions}
              // deleteClientDocument={props.deleteClientDocument}
              // toggleDialogYesNo={props.toggleDialogYesNo}
              // showDialogYesNo={props.showDialogYesNo}
              />
            ) : (
              <>
                {/**HEADER Container**/}
                <Grid
                  item
                  lg={12}
                  md={12}
                  xs={12}
                  sm={12}
                // className="documentsToRequire-header"
                >
                  <HeaderHLPure title={t("documentsToRequire.titleHeader")} />
                </Grid>
                <Grid
                  item
                  xs={12}
                >
                  <Grid container spacing={2} wrap="true" className="documentsToRequire-navbar">
                    <Grid
                      item
                      lg={3}
                      md={6}
                      xs={12}
                    >
                      <ButtonAddHLPure
                        nameBtn={t("documentsToRequire.newDocument")}
                        iconAdd
                        onClickBtn={() => {
                          setNameComponentUser(t("documentsToRequire.newDocument"));
                          setShowDetails(true);
                        }}
                      />
                    </Grid>

                    <Grid
                      item
                      lg={3}
                      md={6}
                      xs={12}
                    >
                      <SearchBarHLPure
                        placeholder={t("documentsToRequire.searchBarPlaceHolder")}
                        onSearchChange={(e) => searchChange(e)}
                      />
                    </Grid>

                    <Grid
                      item
                      lg={4}
                      md={6}
                      xs={12}
                      className="documentsToRequire-filterHLPure"
                    >
                      <FilterHLPure
                        options={personTypes}
                        nameOption="personType"
                        valueItem="name"
                        optionsValue={selectedValueFilter}
                        onFilterChange={(event) => filterChange(event)}
                      />
                    </Grid>
                  </Grid>

                </Grid>

                <Grid item className="documentsToRequire-gridContainer">
                  <GridHLPure
                    {...props}
                    dataGrid={dataUserFiltered}
                    skip={0}
                    take={6}
                    selectedValueFilter={selectedValueFilter}
                    iconAvatar={false}
                    titleRow1={t("documentsToRequire.grid.documents")}
                    fieldRow1={"name"}
                    fieldTitle={"name"}
                    titleRow4={textLimit ? null : t("documentsToRequire.grid.actions")}
                    fieldSubtitle={"newUpdatedDate"}
                    onFilterChange={filterChange}
                    onSelectedItem={setSelectedUser}
                    setShowDetails={setShowDetails}
                    setNameComponentUser={setNameComponentUser}
                    filter={true}
                    columnFour
                    iconOneActiveSelected={"activeBtnOne"}
                    iconOneActive
                    labelOneActions={t("documentsToRequire.grid.delete")}
                    iconTwoActive
                    iconTwoActiveSelected={"defaultDocument"}
                    labelTwoActions={t("documentsToRequire.grid.detail")}
                    labelTwoActions2={"labelBtnTwo"}
                    labelFourthActions={t("documentsToRequire.grid.detailAndEdit")}
                    widthHeader={"documentsToRequireGrid-cellItemStylesTh1"}
                    styleCol1={"documentsToRequireGrid-cellItemStylesCol1"}
                    activeDialog1
                    showDialogYesNo
                    btnOpenDialog1={toggleDialogYesNo}
                    widthHeaderCol4={"documentsToRequireGrid-cellItemStylesTh4"}
                    styleCol4={"documentsToRequireGrid-cellItemStylesCol4"}
                  />
                </Grid>
              </>
            )}
            {showDialogYesNo && (
              <DialogYesNoHLPure
                titleDialog={t("documentsToRequire.dialogDeleteDocumenTitle")}
                textBtnCancel={t("documentsToRequire.dialogCancelButton")}
                saveBtn={t("documentsToRequire.dialogDeleteDocumentButton")}
                cancel={toggleDialogYesNo}
                handleSubmit={deleteClientDocument}
                textBtnCancelDisabled={false}
              >
                <div className="dialogYesNoHLPure-childrenBody">
                  <p>{t("documentsToRequire.dialogConfirmDeleteText")}</p>
                </div>
              </DialogYesNoHLPure>
            )}
            {!nameComponentUser &&
              <Grid
                container
                style={{ justifyContent: "flex-end" }}
              >
                <ButtonHLPure
                  nameBtn={t("button.return")}
                  onClickBtn={() => props.history.push(goBackRoute)}
                />
              </Grid>
            }
            <Grid item xs={12} lg={12} md={12} sm={12}>
              <PromotionalFooterPure />
            </Grid>
          </Grid>
          {/* </Grid> */}
        </Container>
      )}
    </div>
  );
};

export default DocumentsToRequireView;
